import React from "react";
import styles from "./Forms.module.scss";
import { Text, type TextProps } from "@mantine/core";

export const BoxContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.boxContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const BackButton: React.FC<React.ComponentProps<typeof Text>> = ({
  children,
  className,
  ...rest
}) => (
  <Text className={`${styles.backButton} ${className ?? ""}`} {...rest}>
    {children}
  </Text>
);

export const Title: React.FC<React.ComponentProps<typeof Text>> = ({
  children,
  className,
  ...rest
}) => (
  <Text className={`${styles.title} ${className ?? ""}`} {...rest}>
    {children}
  </Text>
);
